import { cn } from '@/lib/utils'
import { memo } from 'react'

const CardDate = ({
  children,
  className,
  mode = 'default'
}: {
  children: React.ReactNode
  className?: string
  mode?: 'default' | 'inverted'
}) => {
  if (!children) {
    return null
  }

  return (
    <div
      className={cn(
        `px-xs py-2xs h4`,
        mode === 'inverted' && 'bg-accent-300 text-white',
        mode === 'default' && 'text-accent-300 bg-neutral-100',
        className
      )}
    >
      {children}
    </div>
  )
}

CardDate.displayName = 'CardDate'

export default memo(CardDate)
